import React from 'react';
import {useIntl} from 'react-intl';
import DataTable from '../../components/dataTable';
import Button from '../../components/button';
import I18nMessage from '../../components/I18nMessage';
import useStore from '../../hooks/use-store';
import {canSeeAuditFields} from '../../helpers/auth';

const CustomerTable = (props) => {
    const intl = useIntl();
    const {store} = useStore();
    const showAuditFields = canSeeAuditFields(store.auth.profile);
    const {
        onPressAdd,
        onPressEdit,
        removeRegister,
        attributes,
        list,
        permissions,
        loading,
        showDeviceList,
    } = props;

    return (
        <DataTable
            add={onPressAdd}
            edit={onPressEdit}
            remove={removeRegister}
            list={list}
            loading={loading}
            attributes={attributes}
            permissions={permissions}
            keyField={'id'}
            confirmText={intl.formatMessage({id: 'customerRemoveConfirm'})}
            headers={[
                {title: 'sharedName', field: 'name', dataSort: true, width: 370},
                {title: 'customerNotificationEmail', field: 'notificationEmail', dataSort: true, width: 330},
                {title: 'customerPhone', field: 'phone', dataSort: true, width: 180},
                {title: 'customerStatus', field: 'status', dataSort: true, width: 120},
                ...(showAuditFields ? [
                    {title: 'sharedCreatedBy', field: 'creatorName', dataSort: true, width: 310},
                    {title: 'sharedCreatorEmail', field: 'creatorEmail', dataSort: true, width: 330},
                    {title: 'sharedCreatedAt', field: 'createdAtFormatted', dataSort: true, width: 210},
                    {title: 'sharedUpdatedAt', field: 'updatedAtFormatted', dataSort: true, width: 210},
                ] : []),
            ]}
            excelConfig={{
                fileName: 'sharedCustomers',
                columns: [
                    {label: 'customerCpfCnpj', field: 'cpfCnpj'},
                    {label: 'customerType', field: 'type'},
                    {label: 'customerName', field: 'name'},
                    {label: 'customerStreet', field: 'street'},
                    {label: 'customerNumber', field: 'number'},
                    {label: 'customerComplement', field: 'complement'},
                    {label: 'customerNeighborhood', field: 'neighborhood'},
                    {label: 'customerCity', field: 'city'},
                    {label: 'customerState', field: 'state'},
                    {label: 'customerPostalCode', field: 'postalCode'},
                    {label: 'customerPhone', field: 'phone'},
                    {label: 'customerCellphone', field: 'cellphone'},
                    {label: 'customerNotificationEmail', field: 'notificationEmail'},
                    {label: 'customerSecondaryEmail', field: 'secondaryEmail'},
                    {label: 'customerCategory', field: 'category'},
                    {label: 'customerStatus', field: 'status'},
                    {label: 'customerNotes', field: 'notes'},
                    // {label: 'customerDisabled', field: (col) => col.disabled ? intl.formatMessage({id: 'sharedYes'}) : intl.formatMessage({id: 'sharedNo'})},
                    // {label: 'customerRegistrationDate', field: (col) => formatDateTimeColumn(col, timezone)},
                    // {label: 'customerExpirationDate', field: (col) => formatDateTimeColumn(col, timezone)},
                    {label: 'customerInvoiceDay', field: 'invoiceDay'},
                    {label: 'customerAttributes', field: 'attributes'},
                ],
            }}
            extraHeaderEl={ (row, disabled) => <Button
                className={'outline'}
                disabled={disabled}
                color={'theme'}
                size={'sm'}
                onClick={() => showDeviceList(row)}
            >
                <i className="fas fa-car"/> <I18nMessage id='deviceTitle'/>
            </Button>}
        />);
};

export default CustomerTable;
